import React, { useEffect, useState } from "react";
import { useItemsFine } from "../../actions/app/items";
import log from "cslog";
import PreviewTemplate from "./PreviewTemplate";
import { Button, Modal } from "antd";
import LoadingBox from "../../common/LoadingBox";
import useMedia from "react-use/lib/useMedia";
import { shuffle } from "../../_helpers/array";
import { useSingleItem } from "../../_actions/app/items";
import { useAtomValue } from "jotai";
import { currentActionAtom } from "../../ai_home/atoms";
import { useCreationHistory } from "../../_actions/mutations/creation_history";
import { useRandomTemplatesNew } from "../../_actions/bot";

const FIELDS =
    "id,type,title,preview.id,preview.filename_disk,tags.qdb_tag_id.*,inputs,used_schemas.qdb_creation_schema_id.id,used_schemas.qdb_creation_schema_id.name,used_schemas.qdb_creation_schema_id.user_prompt_question,used_schemas.qdb_creation_schema_id.inputs";

export const DesignTemplates = ({
    me,
    // filter,
    preset_id,
    primary_tag,

    open,
    setOpen,
    enable = false,
    default_template_id = null,
    history_id,
    renderTemplate = () => {},
    renderLoading,
    renderError = () => {},
    onUpdate = () => {},
}) => {
    // const { isSuccess, isLoading, data } = useItemsFine(
    //     "qdb_creation_template",
    //     filter
    //         // ? `fields=id,type,title,preview.id,preview.filename_disk&filter=${filter}`
    //         ? `fields=id,type,title,preview.id&filter=${filter}`
    //         : "",
    //     enable
    // );
    const {
        isSuccess: successPreset,
        isLoading: loadingPreset,
        data: dataOriginPreset,
    } = useSingleItem(
        "qdb_creation_schema",
        `/${preset_id}?fields=*.*`,
        !!preset_id,
    );
    console.log(dataOriginPreset, "dataOriginPreset in DesignTemplates");
    const origin_preset = dataOriginPreset?.origin_preset?.id;
    const finalPresetId = origin_preset || preset_id;
    const { isSuccess, isLoading, data } = useRandomTemplatesNew(
        finalPresetId,
        primary_tag,
        "id,type,title,is_themeable,preview",
        12,
        enable && successPreset,
    );
    const [selected_item, setSelectedItem] = useState(null);
    const {
        isLoading: loadingDesign,
        isSuccess: successDesign,
        data: dataDesign,
    } = useSingleItem(
        "qdb_creation_template",
        `/${selected_item?.id}?fields=*,types.qdb_creation_type_id.name`,
        !!selected_item?.id,
    );
    const [selected_index, setSelectedIndex] = React.useState(null);
    const [list, setList] = useState([]);
    const isMobile = useMedia("(max-width: 700px)");
    const current_action = useAtomValue(currentActionAtom);

    const {
        addTemplateInHistory,
        isLoading: loadingHistory,
        isSuccess: successHistory,
    } = useCreationHistory(
        history_id,
        () => {},
        () => {},
    );

    useEffect(() => {
        if (default_template_id) {
            setSelectedItem({
                id: default_template_id,
            });
            if (history_id) {
                addTemplateInHistory(default_template_id);
            }
        }
    }, [default_template_id]);

    useEffect(() => {
        if (isSuccess && selected_index && data?.length >= selected_index) {
            setSelectedItem(data[selected_index]);
            // onUpdate(data[selected_index]);
        }
    }, [selected_index, isSuccess]);

    useEffect(() => {
        if (successDesign && dataDesign) {
            onUpdate(dataDesign);
        }
    }, [successDesign, dataDesign]);

    useEffect(() => {
        if (isSuccess && data.length > 0) {
            const temp_arr = data;
            shuffle(temp_arr);
            setList(temp_arr);
            // setSelectedIndex(0);
            // setSelectedItem(data[0]);
            if (!default_template_id) {
                setSelectedIndex(0);
                setSelectedItem(data[0]);
            }
        }
    }, [isSuccess, data]);

    const next = () => {
        if (data && data.length > 0) {
            if (selected_index !== null) {
                if (selected_index === list.length - 1) {
                    setSelectedIndex(0);
                } else {
                    setSelectedIndex(selected_index + 1);
                }
            } else {
                setSelectedIndex(0);
                setSelectedItem(data[0]);
            }
        }
    };

    useEffect(() => {
        if (current_action) {
            switch (current_action.id) {
                case "redesign":
                    next();
                    break;
            }
        }
    }, [current_action]);

    log.d(data, "list in DesignTemplates");
    log.d(selected_item, "selected_item in DesignTemplates");
    log.d(dataDesign, "dataDesign in DesignTemplates");

    if (isLoading) {
        if (renderLoading) return renderLoading();
        return (
            <Modal open={open} footer={null} onCancel={() => setOpen(false)}>
                <LoadingBox />
            </Modal>
        );
    } else if (isSuccess && data?.length === 0) {
        return <>{renderError && renderError("No creation found for this")}</>;
        // return <Modal open={open} footer={null} onCancel={() => setOpen(false)} >
        //     <p>No creation found for this</p>
        // </Modal>
    } else if (loadingDesign) {
        if (renderLoading) return renderLoading();
        return (
            <Modal open={open} footer={null} onCancel={() => setOpen(false)}>
                <LoadingBox />
            </Modal>
        );
    }

    return <>{successDesign && renderTemplate(dataDesign)}</>;
};
